import React, { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
    const context = useContext(CurrencyContext);
    if (!context) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
};

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState('INR');

    const currencies = {
        INR: { symbol: '₹', name: 'Indian Rupee', rate: 1, icon: 'fa-rupee-sign' },
        USD: { symbol: '$', name: 'US Dollar', rate: 0.012, icon: 'fa-dollar-sign' },
        AED: { symbol: 'د.إ', name: 'UAE Dirham', rate: 0.044, icon: 'fa-money-bill' },
        MYR: { symbol: 'RM', name: 'Malaysian Ringgit', rate: 0.053, icon: 'fa-money-bill-wave' }
    };

    const convertPrice = (priceInINR) => {
        const numericPrice = typeof priceInINR === 'string' 
            ? parseFloat(priceInINR.replace(/[₹,]/g, ''))
            : priceInINR;
        
        const convertedPrice = numericPrice * currencies[currency].rate;
        return `${currencies[currency].symbol}${convertedPrice.toFixed(2)}`;
    };

    const formatPrice = (price) => {
        if (typeof price === 'string' && price.includes('Saved')) {
            const numericPart = price.replace(/[₹,]/g, '').replace(' Saved', '');
            const converted = parseFloat(numericPart) * currencies[currency].rate;
            return `${currencies[currency].symbol}${converted.toFixed(2)} Saved`;
        }
        return convertPrice(price);
    };

    return (
        <CurrencyContext.Provider value={{ 
            currency, 
            setCurrency, 
            currencies, 
            convertPrice,
            formatPrice,
            currentCurrency: currencies[currency]
        }}>
            {children}
        </CurrencyContext.Provider>
    );
};
